import React from 'react'
import { NavLink } from 'react-router-dom';
import CompanyLogo from '../../../Components/CompanyLogo'
import RandomLogo from '../../../Components/RandomLogo'
import { routeNames } from '../../../routeSegments';
import OverflowToolTip from '../../shared/OverflowToolTip';

/* The above code is a React component called `AdvisorInfo`. It renders a section of advisor
information. */
const AdvisorInfo = (props) => {
    
    return (

        <div
            className="lg:grid lg:grid-rows-8 gap-6">
            <div className="w-full lg:grid lg:grid-rows-8 lg:grid-flow-col overflow-x-auto scrollbar ">
                <div
                    className="row-span-3 ">
                    <div className="px-5 ">
                        <div
                            className="row-span-1">
                            <p
                                className="text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold  lg:leading-[22px]">
                                Advisor Info</p>
                            <div
                                className="w-full ">
                                {props?.data ?
                                    props?.data?.companyAdvisor?.length > 0 || props?.data?.investorAdvisor?.length > 0 ?
                                        <div className="grid grid-cols-2 gap-4 text-[12pt] leading-[16pt] text-[#333333] lg:text-[14px] lg:leading[16px] font-sans_book_body ">
                                            <div
                                                    className="leading-[21px] py-2 px-1 md:px-3.5">
                                                    <p
                                                        className="whitespace-nowrap font-normal mb-3">
                                                        To Buyer
                                                    </p>
                                                    {props?.data?.investorAdvisor?.length > 0 ?
                                                        props?.data?.investorAdvisor.map((data, i) => {
                                                            return (
                                                                <div className='leading-8 flex items-center py-3 grid grid-cols-5'>
                                                                 <div className='col-span-1'>   {data?.logo_path == "default.png" || data?.logo_path == "/default.png" || !data?.logo_path ?
                                                                        <RandomLogo name={data?.cia_name} />
                                                                        :
                                                                        <CompanyLogo name={data?.cia_name} page="company page" logo={data?.logo_path} />
                                                                    }</div>
                                                                    <div className='col-span-4'><OverflowToolTip component={
                                                                        <NavLink  to={
                                                                            data.advisor_type=='L' ? routeNames.reAdvisorById(data?.cia_id) 
                                                                            :routeNames.reTransactionAdvisorById(data?.cia_id) 
                                                                            } 
 
                                                                         className="mt-2 whitespace-nowrap font-semibold hover:text-[#BC8B20] text-[#333333]">
                                                                         {data.cia_name ? data.cia_name : "--"}
 
                                                                             {data.advisor_type ? (" (" + data.advisor_type + (data.advisor_subtype ? " - " + data.advisor_subtype : "") + ")") : ""}
                                                                         </NavLink> } 
                                                                    /></div>
                                                                </div>
                                                            )
                                                        })
                                                        : <><p className="mt-2">--</p></>
                                                    }
                                            </div>
                                            <div
                                                className="lg:leading-[21px] py-2 pr-3.5">
                                                <p
                                                    className="whitespace-nowrap font-normal mb-3">
                                                    To Seller
                                                </p>
                                                {props?.data?.companyAdvisor?.length > 0 ?
                                                    props?.data?.companyAdvisor.map((data, i) => {
                                                        return (
                                                            <div className='leading-8 flex items-center py-3'>
                                                                {data?.logo_path == "default.png" || data?.logo_path == "/default.png" || !data?.logo_path ?
                                                                    <RandomLogo name={data?.cia_name} />
                                                                    :
                                                                    <CompanyLogo name={data?.cia_name} page="company page" logo={data?.logo_path} />
                                                                }
                                                                <OverflowToolTip component={
                                                                    <NavLink  to={
                                                                    data.advisor_type=='L' ? routeNames.reAdvisorById(data?.cia_id) 
                                                                    :routeNames.reTransactionAdvisorById(data?.cia_id) 
                                                                    } 

                                                                    className="mt-2 whitespace-nowrap font-semibold hover:text-[#BC8B20] text-[#333333]">
                                                                    {data.cia_name ? data.cia_name : "--"}

                                                                        {data.advisor_type ? (" (" + data.advisor_type + (data.advisor_subtype ? " - " + data.advisor_subtype : "") + ")") : ""}
                                                                    </NavLink> 
                                                                    
                                                                    } 
                                                                />
                                                            </div>

                                                        )
                                                    })
                                                    : <><p className="mt-2"></p></>
                                                }

                                            </div>                                            
                                        
                                        </div>
                                        : <center><div className="bg-[#F3F3F3] mb-4 p-3 h-[2.5rem] text-[14px] leading-[16px] font-sans_book_body text-[#333333] relative mt-[1rem] ">No data available</div></center>
                                    :
                                    <div className="w-full bg-[#FFFFFF]">
                                        <center><div role="status" className=" h-[8rem]">
                                            <svg className="relative top-[4rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                        </div></center>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    )
}

export default AdvisorInfo